import { atom } from "recoil";

export const emailIsState = atom({
  key: "emailIsState",
  default: "",
});
export const fullNameIsState = atom({
  key: "fullNameIsState",
  default: "",
});
export const passwordIsState = atom({
  key: "passwordIsState",
  default: "",
});
export const allUsersState = atom({
  key: "allUsersState",
  default: [],
});
export const currentUserState = atom({
  key: "currentUserState",
  default: "",
});
export const currentUserAccessToken = atom({
  key: "currentUserKey",
  default: null,
});

export const currentUserInfo = atom({
  key: "currentUserInfo",
  default: null,
});

export const currentAvailabilityData = atom({
  key: "currentAvailabilityData",
  default: [],
});

export const currentUploadedDocuments = atom({
  key: "currentUploadedDocuments",
  default: [],
});

export const currentTimeOff = atom({
  key: "currentTimeOff",
  default: [],
});
export const signInResponseErrorState = atom({
  key: "signInResponseErrorState",
  default: null,
});
export const latestLoginTimeState = atom({
  key: "latestLoginTimeState",
  default: null,
});
export const globalLoadingState = atom({
  key: "globalLoadingState",
  default: true,
});
